import React, { Fragment } from 'react';
import { Table, Header, Segment, Loader, Message, Responsive } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class StudentPassedExams extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentId: '',
            studyProgramId: '',

            grades: [],
            ectsTotal: null,
            gradeAverage: null,
            loading: true,
            error: false,
        };
        this.fetchGrades = this.fetchGrades.bind(this);
    }
    componentDidMount() {
        this.fetchGrades();
    }
    fetchGrades() {
        axios.get('/student-exams/all-grades/')
            .then(res => {
                const { grades, ectsTotal, gradeAverage } = res.data;
                if (!grades) {
                    this.setState({ error: true, loading: false });
                    return;
                }
                this.setState({
                    grades,
                    ectsTotal,
                    gradeAverage,
                    loading: false
                });
            })
            .catch(err => {
                toast(<FormattedMessage id="common.error" />);
                this.setState({ error: true });
            });
    }
    render() {
        const { grades, gradeAverage, ectsTotal } = this.state;
        return (
            <div>
                <Header as="h1"><FormattedMessage id="student.study" /></Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3"><FormattedMessage id="student.showGrades" /></Header>
                    </Segment>
                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                    <Segment >
                            { grades.length ?
                            <PassedExamsTable
                                    grades={grades}
                                    gradeAverage={gradeAverage}
                                    ectsTotal={ectsTotal}
                                /> : <FormattedMessage id="student.noGradesMessage" />}
                        </Segment>}
                </Segment.Group>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

const PassedExamsTable = ({ grades, gradeAverage, ectsTotal }) => (<Fragment>
    <Message
        size="tiny"
        warning
        header="Žutom bojom su označene ocjene koje još uvijek nisu finalizirane."
        content="Ove ocjene se neće prikazivati na prepisu ocjena dok ih profesor/ica ne finalizira. U slučaju greške, obratite se odgovarajućem profesoru/ici ili studentskoj službi."
    />
    <Table stackable celled selectable structured>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                <Table.HeaderCell colSpan={2}><FormattedMessage id="common.course" /></Table.HeaderCell>
                {/* <Table.HeaderCell width='1'>{<FormattedMessage id="common.semester" />}</Table.HeaderCell> */}
                <Table.HeaderCell><FormattedMessage id="common.teacher" /></Table.HeaderCell>
                <Table.HeaderCell><FormattedMessage id="professorInputGrades.examOnlyDate" /></Table.HeaderCell>
                <Table.HeaderCell width="1">ECTS</Table.HeaderCell>
                <Table.HeaderCell ><FormattedMessage id="common.grade" /></Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {grades.map((row, index) => (
                <Table.Row key={row.id}>
                    <Table.Cell width="1" verticalAlign="middle" warning={row.markStatus === null}>
                        {index + 1}.
                    </Table.Cell>
                    <Table.Cell colSpan={2} verticalAlign="middle" warning={row.markStatus === null}>{row.courseName}</Table.Cell>
                    {/* <Table.Cell verticalAlign="middle">{row.semester}</Table.Cell> */}
                    <Table.Cell verticalAlign="middle" warning={row.markStatus === null}>{row.teacher}</Table.Cell>
                    <Table.Cell verticalAlign="middle" warning={row.markStatus === null}>{moment(row.examDate).format('D. M. YYYY.')}</Table.Cell>
                    <Table.Cell verticalAlign="middle" warning={row.markStatus === null}>{row.ects}</Table.Cell>
                    <Table.Cell verticalAlign="middle" warning={row.markStatus === null}>{row.mark}</Table.Cell>
                </Table.Row>
            ))}
        </Table.Body>
        <Table.Footer>
            <Table.Row>
                <Table.HeaderCell colSpan={5} rowSpan={3} />
                <Table.HeaderCell colSpan={2} >
                    <Header as="h4" >
                        <FormattedMessage id="common.totalEcts" />{' '}{ectsTotal}
                    </Header>
                </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
                <Table.HeaderCell colSpan={2}>
                    <Header as="h4" >
                        <FormattedMessage id="common.gradeAverage" /> {gradeAverage}
                    </Header>
                </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
                <Table.HeaderCell colSpan={2}>
                    <Header as="h4" >
                        <FormattedMessage id="student.passedExamsNumber" />: {grades.length}
                    </Header>
                </Table.HeaderCell>
            </Table.Row>
        </Table.Footer>
    </Table>
</Fragment>

);

/*
  semester, courseName, teacher, examDate, ects, mark

*/



// WEBPACK FOOTER //
// ./src/views/StudentPassedExams/StudentPassedExams.js